function ClientForm($form) {
    // Consts
    var DISABLE = true;
    var ENABLE = false;

    var formSelector = ($form && $form[0] && $form[0].id) ? '#' + $form[0].id : '';
    var btnSaveSelector = `${formSelector} .btn-save`;
    var orgSelector = `${formSelector} select[name="OrganizationID"]`;

    var refNumberInput = new ClientReferenceNumberInput($form);

    var m = {
        isMultiOrganization: function() {
            // if no multi organizqtion
            // - input hidden [name="OrganizationID"]
            // else
            // - input hidden [name="OrganizationID"]
            // - select [name="OrganizationID"]
            return ($(`${formSelector} select[name="OrganizationID"]`).length > 0)
        },

        isDVA: function() {
            var isDVA = $(`${formSelector} #isDVA`).val() || '';
            return (isDVA.toString() === 'true');
        },

        initListeners: function() {
            m.unbindClickBtnSave();
            m.initDVA();
            m.onClickBtnSave();
            m.onOrganizationChange();

            m.setIsDVA();
            m.checkShowHideDVA();
        },


        /*

            INPUTS

         */

        toggle: function(isDisabled) {
            $form.find('input[type="text"], input[type="tel"], input[type="radio"], textarea, select').prop('readonly', isDisabled).prop("disabled", isDisabled);
            $form.find('select').prop('disabled', isDisabled);
            $form.find('select').each(function(index, elem) {
                $(elem).data("kendoDropDownList") && $(elem).data("kendoDropDownList").enable(! isDisabled);
            });

            $form.find(".addressbook-popup__date input").each(function(index, elem) {
                $(elem).data("kendoDatePicker") && $(elem).data("kendoDatePicker").enable(!isDisabled);
            })

            $form.find('input[type="radio"]').prop('disabled', isDisabled).uniform();

            (!isDisabled)
                ? $form.find('.acfi-show').removeClass('k-state-disabled')
                : $form.find('.acfi-show').addClass('k-state-disabled')
        },

        enable: function() {
            m.toggle(ENABLE);
        },

        disable: function() {
            m.toggle(DISABLE);
        },

        reset: function() {
            $form.find('input[type="text"], input[type="tel"], textarea').val('');

            $form.find('select').each(function(index, elem) {
                $(elem).data("kendoDropDownList")
                    && ( $(elem).data("kendoDropDownList").enable(false)
                       , $(elem).data("kendoDropDownList").value('')
                       , $(elem).data("kendoDropDownList").trigger("change"));
            });
        },

        disableForm: function() {
            m.disable();
            m.resetOrganisation();
            m.disableSaveBtn();
            m.resetValidation();
        },

        enableForm: function() {
            m.enable();
            m.enableSaveBtn();
        },

        /**


            VALIDATION


         */

        resetValidation: function() {
            var validator = $form.find("form").validate();
            validator.resetForm();

            $form.find('.error').removeClass('error');
        },

        checkSelect: function() {
            $form.find('select[name="BillingState"]').each(function(i, elem) {
                SelectValidator(elem).isValid();
            });

            m.isDVA()
                && m.isDVAValid();
        },


        /**


            SAVE BTN


         */

        toggelSaveBtn: function(isDisabled) {
            $(btnSaveSelector).last().attr("disabled", isDisabled);
        },

        disableSaveBtn: function() {
            m.toggelSaveBtn(DISABLE);
        },

        enableSaveBtn: function() {
            m.toggelSaveBtn(ENABLE);
        },

        onClickBtnSave: function() {
            var $formDom = $form.find('form').last();
            var $btn = $(btnSaveSelector);

            function submitOnValid(e) {
                e.preventDefault();

                // Enable ignore for jquery.unobstrusive
                // Unfortunately the ignore property in validate
                // doesn't work because of jquery.unobstrusive
                var form = $($formDom).get(0);
                if (form) {
                    // pre fire valid to force generate the setting object
                    $formDom.valid();

                    $.data(form, "validator") &&
                    $.data(form, "validator").settings &&
                        ($.data(form, "validator").settings['ignore'] = ":hidden, .dva");
                }

                // re-enable for hidden select
                var $dropdown = $formDom.find('select:hidden');
                var isSelectValid = true;
                $.each($dropdown, function(index, el) {
                    if (!el.closest('.d-none')) {
                        if ($(el).prop('required')) {
                            // can't add select validation dynamically cause it's already on ignore's list (:hidden)
                            isSelectValid = !!$(el).val();
                        }
                    }
                });

                var isValidSave = $formDom.valid();
                var isValidDVA = m.isDVAValid();

                m.checkSelect();

                if (isValidSave && isValidDVA && isSelectValid) {
                    $formDom.trigger('submit');
                    return;
                }
            }

            $btn.on('click', submitOnValid);
        },

        unbindClickBtnSave: function() {
            $(btnSaveSelector).unbind('click');
        },


        /*


            ORGANIZATION


        */

        onOrganizationChange: function(clb) {
            $(orgSelector).on('change', function(val) {
                var val = $(this).val();

                (val !== "")
                    ? m.enableForm()
                    : m.disableForm();

                m.setIsDVA();
                m.checkShowHideDVA();
                m.setRefNumberLabel();
            });
        },

        resetOrganisation: function() {
            if (! m.isMultiOrganization()) {
                return;
            }

            $orgKendo = $(orgSelector).kendoDropDownList();
            $(orgSelector).val('');
            $orgKendo.data('kendoDropDownList').value('');

            m.enableOrg()
        },

        toggleOrg: function(isDisabled) {
            $(orgSelector).prop('readonly', !isDisabled);
            $(orgSelector).prop('disabled', !isDisabled);

            $orgKendo = $(orgSelector).kendoDropDownList();

            ($orgKendo.length > 0)
                && $orgKendo.data('kendoDropDownList').enable(!isDisabled);
        },

        enableOrg: function() {
            m.toggleOrg(ENABLE);
        },

        disableOrg: function() {
            m.toggleOrg(DISABLE);
        },


        /**


            DVA


         */

        initDVA: function() {
            var selector = formSelector;

            $("[type=radio]").uniform();
            $("select").kendoDropDownList();

            setTimeout(function() {
                Core.DVAInformation.init({
                    root: selector,
                    datepickerInput: ".addressbook-popup__date input",
                    domActivites: `${selector} #clientPopupDVAActivities`,
                    domBehaviour: `${selector} #clientPopupDVABehaviour`,
                    domComplexHealthCare: `${selector} #clientPopupDVAComplex`,
                });
            }, 500);
        },

        setIsDVA: function(portalId) {
            if (! m.isMultiOrganization()) {
                return;
            }

            function isDVA(portalId) {
                var select = $(orgSelector);
                var dvaMap  = select && select.data("dva");

                if (! dvaMap) {
                    return false;
                }

                return dvaMap.indexOf(portalId) > -1;
            }

            var key = $(orgSelector).val();
            $(`${formSelector} #isDVA`).val(isDVA(key));
        },

        checkShowHideDVA : function() {
            m.isDVA()
                ? m.showDVASection()
                : m.hideDVASection();
        },

        hideDVASection: function() {
            $('.dva-information').addClass('d-none');
        },

        showDVASection: function() {
            $('.dva-information').removeClass('d-none');
        },

        setRefNumberLabel: function() {
          var $label = $(`${formSelector} label[for="clientPopupReferenceNumber"]`);
          if (m.isDVA()) {
            $label.html(`DVA File Number <span class="req">*</span>`);
          } else {
            $label.html(`Client Reference Number <span class="req">*</span>`);
          }
        },

        isDVAValid: function() {
            if (!m.isDVA()) {
                return true;
            }

            return Core.DVAInformation.isValid({
                dvaCardType: `${formSelector} #clientPopupDVACardTypeEdit`,
                dvaDOB: `${formSelector} #clientPopupDVADOB`,
                dvaRCF: `${formSelector} #yes_rcf`,
                dvaADL: `${formSelector} #clientPopupDVAActivities`,
                dvaBEH: `${formSelector} #clientPopupDVABehaviour`,
                dvaCHC: `${formSelector} #clientPopupDVAComplex`,

                dvaFundingOther: `${formSelector} #yes_DVAFundingOther`, // yes_FundingOther
                dvaFundingOtherType: `${formSelector} #DVAFundingOtherType`, // dvaFundingOtherType
            });
        },
    };

    m.initListeners();

    return m;
}
